module.exports = __webpack_public_path__ + "static/media/fashion-7.a88f92dd.jpg";